import React from 'react';
import UserCreate from '../../components/callcenter/UserCreate';

const CallcenterUserCreatePage = () => {
  return <UserCreate />;
};

export default CallcenterUserCreatePage;

